import React from 'react'
import Layout from '../../Layout/Layout'
import DataTable from './Table'

const Projects = () => {
  return (
   <Layout>
     <DataTable/>
    </Layout>
  )
}

export default Projects
